import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import ImageCellRenderer from './CustomCells/ImageCellRenderer';
import { AgGridReact } from 'ag-grid-react';

export interface TableComponentProps {
  data?: any;
  searchVal?: string;
  openModal?: Function;
  getFilteredData?: Function;
}

const TableComponent: React.FC<TableComponentProps> = ({ data, searchVal, openModal,getFilteredData }) => {

  const [columns, setColumns] = useState<any>([]);
  const [rows, setRows] = useState<any>([]);
  const [allRows, setAllRows] = useState<any>([]);
  const [original, setOriginal] = useState<any>([]);

  const DefaultColumns = [ 
    { field: 'Device ID' },
    { field: 'Device Type' },
    { field: 'Device Status' },
    { field: 'Truck Number' },
    { field: 'Truck Type' },
    { field: 'Service Type' },
    { field: 'Service Provider' },
    { field: 'Segment Name' },
    { field: 'Last Reported On' },
    { field: 'Event' },
    { field: 'Received Time' },
    { field: 'Longitude' },
    { field: 'Latitude' },
    { field: 'Address' },
    { field: 'Observation Number' },
    { field: 'Obs Description' },
    { field: 'Last Image Url' },
    { field: 'Last Image Time' },
    { field: 'Last Image-2 Url' },
    { field: 'Last Image-2 Time' }
  ];

 

  // filters table for when user types in search value
  useEffect(() => {
    if (searchVal && searchVal !== "") {
        let daraRows = [...allRows];
      let newRows = daraRows.filter((r: any) => JSON.stringify(r).toLowerCase().includes(searchVal.toLowerCase()));
      setRows(newRows);
    } else {
      setRows(original);
    }
  }, [searchVal]);

  var dateFilterParams = {
    comparator: function (filterLocalDateAtMidnight: any, cellValue: any) {
      var dateAsString = cellValue;
      if (dateAsString == null) return -1;
      var dateParts = dateAsString.split('/');
      var cellDate = new Date(
        Number(dateParts[2].includes(',') ? dateParts[2].split(',')[0] : dateParts[2].split(' ')[0]),
        Number(dateParts[0]) - 1,
        Number(dateParts[1])
      );
      if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
        return 0;
      }
      if (cellDate < filterLocalDateAtMidnight) {
        return -1;
      }
      if (cellDate > filterLocalDateAtMidnight) {
        return 1;
      }
      return 0;
    },
    minValidYear: 2000,
    maxValidYear: new Date().getFullYear()
  };

  // grabs data and sets columns and rows for mui data grid
  useEffect(() => {
    if (data && data.length > 0) {
      let flatData = data.map((item: any) => ({ ...item.data, ...item }));
      //console.log(flatData);
      if (flatData.metadata) {
        flatData = flatData.map((item: any) => ({ ...item.metadata, ...item }));
      }
      let keys = Object.keys(flatData[0]);

      let newRows = [];
      let newKeys = [];

      // rows
      for (let z = 0; z < flatData.length; z++) {
        let newRow = {
          ...flatData[z],
        }
        newRows.push(newRow);
      }

      // columns
      for (let i = 0; i < keys.length; i++) {
        let obj: any = null;

        if (keys[i] === "deviceName") {
          obj = { headerName: 'Device ID', field: keys[i] }
        }
        else if (keys[i] === "deviceType") {
          obj = { headerName: 'Device Type', field: keys[i] }
        }
        else if (keys[i] === "deviceStatus") {
          obj = { headerName: 'Device Status', field: keys[i] }
        }
        else if (keys[i] === "truckName") {
          obj = { headerName: 'Truck Number', field: keys[i] }
        }
        else if (keys[i] === "truckType") {
          obj = { headerName: 'Truck Type', field: keys[i] }
        }
        else if (keys[i] === "serviceType") {
          obj = { headerName: 'Service Type', field: keys[i] }
        }
        else if (keys[i] === "serviceProvider") {
          obj = { headerName: 'Service Provider', field: keys[i] }
        }
        else if (keys[i] === "segmentName") {
          obj = { headerName: 'Segment Name', field: keys[i] }
        }
        else if (keys[i] === "lastReportedEventTime") {
          obj = { headerName: 'Last Reported On', field: keys[i], filter: 'agDateColumnFilter', filterParams: dateFilterParams }
        }
        else if (keys[i] === "lastReportedEventType") {
          obj = { headerName: 'Event', field: keys[i] }
        }
        else if (keys[i] === "receivedTime") {
          obj = { headerName: 'Received Time', field: keys[i], filter: 'agDateColumnFilter', filterParams: dateFilterParams }
        }
        else if (keys[i] === "longitude") {
          obj = { headerName: 'Longitude', field: keys[i] }
              }
        else if (keys[i] === "latitude") {
          obj = { headerName: 'Latitude', field: keys[i] }
              }
        else if (keys[i] === "address") {
          obj = { headerName: 'Address', field: keys[i] }
              }
        else if (keys[i] === "obsNumber") {
          obj = { headerName: 'Observation Number', field: keys[i] }
              }
        else if (keys[i] === "obsDescription") {
          obj = { headerName: 'Obs Description', field: keys[i] }
          }
        else if (keys[i] === "lastImageUrl") {
          obj = {
            field: keys[i], minWidth: 300,
            resizable: true,
                cellRendererSelector: (params: any) => {
              return { component: ImageCellRenderer }
            },
                cellRendererParams: openModal ?
                    {
                        editAction: (modal: any, user: any) => openModal(modal)
                    } :
                    {}
            }
        }
        else if (keys[i] === "lastImageUrl2") {
          obj = {
            headerName: 'Last Image-2 Url',
            field: keys[i], minWidth: 300,
            resizable: true,
                cellRendererSelector: (params: any) => {
              return { component: ImageCellRenderer }
            },
                cellRendererParams: openModal ?
                    {
                        editAction: (modal: any, user: any) => openModal(modal)
                    } :
                    {}
            }
        }
        else if (keys[i] === "lastImageTime") {
          obj = { headerName: 'Last Image Time', field: keys[i], filter: 'agDateColumnFilter', filterParams: dateFilterParams }
        }
        else if (keys[i] === "lastImageTime2") {
          obj = { headerName: 'Last Image-2 Time', field: keys[i], filter: 'agDateColumnFilter', filterParams: dateFilterParams }
        }
        if (obj) {
          if (keys[i] === "deviceId")
              newKeys.unshift(obj);
          else
              newKeys.push(obj);
            }
      }
      setColumns(newKeys);
      setRows(newRows);
      setOriginal(newRows);
      setAllRows(newRows);
    }
    else {
      setRows([]);
      setOriginal([]);
      setColumns(DefaultColumns);
      setAllRows([]);
    }
  }, [data]);

  const defaultColDef = {
    sortable: true,
    resizable: true,
    filter: true
  };

  
    // Downloading Only Filtered Data After Search
    useEffect(() => {
      if (getFilteredData)
        getFilteredData(rows);
    },[rows]);

  return (
    <Box className="ag-theme-material" sx={{ height: "75%", width: '100%' }}>
      <AgGridReact
        rowData={rows}
        columnDefs={columns}
        pagination={true}
        paginationPageSize={200}
        suppressHorizontalScroll={false}
        rowSelection={"single"}
        rowHeight={40}
        headerHeight={35}    
        defaultColDef={defaultColDef}
        enableRangeSelection={true}
      >
      </AgGridReact>
    </Box>
  );
}

export default TableComponent;
